import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { makeImportBackend } from './import-backend'
import { i18nConfig } from './i18n-hooks'

export interface I18nConfigOptions {
  namespaces: readonly string[]
  defaultNS?: string
  // biome-ignore lint/suspicious/noExplicitAny: <explanation>
  languages: Record<string, () => Promise<any>>
  detection?: {
    order?: string[]
    caches?: string[]
    lookupLocalStorage?: string
  }
  interpolation?: {
    escapeValue?: boolean
  }
}

export const createI18nConfig = (options: I18nConfigOptions) => {
  const {
    namespaces,
    defaultNS = 'shared',
    detection = {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'preferredLanguage',
    },
    interpolation = {
      escapeValue: false,
    },
  } = options
  return {
    fallbackLng: 'en',
    ns: namespaces,
    defaultNS,
    interpolation,
    detection,
  }
}

export const initI18n = (options: I18nConfigOptions) => {
  const config = createI18nConfig(options)

  i18n
    .use(makeImportBackend(options.languages))
    .use(initReactI18next)
    .use(LanguageDetector)
    .init(config)

  i18nConfig.namespaces = options.namespaces as string[]
}

export const setLocale = (language: string) => i18n.changeLanguage(language)
export const i18t = i18n.t
export const i18tArgs = (...args: Parameters<typeof i18n.t>): unknown[] => args
